import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getTenantsByParentId = async (tenantId?: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenants`,
    {
      params: {
        tenantid: tenantId
      }
    }
  );

  return data;
};

export const getTenants = async (tenantId?: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenant`,
    {
      params: {
        tenantid: tenantId
      }
    }
  );

  return data;
};

export const createTenants = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenant`,
    createInfo,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }
  );

  return data;
};

export const updateTenants = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenant/${updateInfo?.id!}`,
    {
      ...updateInfo,
      id: undefined,
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }
  );

  return data;
};

export const deleteTenant = async (tenantId: number) => {
  const { data } = await IBModuleApi.delete(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenant/${tenantId}`
  );

  return data;
};

export const reactiveTenants = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenant/reactivate/${updateInfo?.id!}`);

  return data;
};

export const getListTenantsWithApplications = async (tenantId?: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenants-info`,
    {
      params: {
        tenantid: tenantId,
      }
    }
  );

  return data;
};
